import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import InsightsSectionML from '../components/sections/InsightsSectionML';
import FeaturedBrandStudioArticle from '../components/sections/FeaturedBrandStudioArticle';
import { useLanguage } from '../contexts/LanguageContext';

const COPY = {
  en: {
    eyebrow: 'Insights',
    title: 'News & Industry Insights',
    lede: 'Stay informed with the latest developments from Grupo BMP and the global business landscape.',
    cta_title: 'Stay Connected',
    cta_body: 'Get in touch to learn more about our latest initiatives and partnerships.',
    cta_btn: 'Contact Us',
  },
  pt: {
    eyebrow: 'Análises',
    title: 'Notícias e Análises do Sector',
    lede: 'Acompanhe os últimos desenvolvimentos do Grupo BMP e do panorama empresarial global.',
    cta_title: 'Mantenha-se em contacto',
    cta_body: 'Fale connosco para conhecer as nossas iniciativas e parcerias mais recentes.',
    cta_btn: 'Falar connosco',
  },
  fr: {
    eyebrow: 'Insights',
    title: 'Actualités et perspectives du secteur',
    lede: 'Restez informé des dernières évolutions du Groupe BMP et du paysage économique mondial.',
    cta_title: 'Restons en contact',
    cta_body: 'Contactez-nous pour découvrir nos initiatives et partenariats récents.',
    cta_btn: 'Nous contacter',
  },
  ar: {
    eyebrow: 'رؤى',
    title: 'أخبار ورؤى صناعية',
    lede: 'ابقَ على اطّلاع بأحدث تطورات مجموعة BMP والمشهد التجاري العالمي.',
    cta_title: 'ابقَ على تواصل',
    cta_body: 'تواصل معنا للاطّلاع على أحدث مبادراتنا وشراكاتنا.',
    cta_btn: 'تواصل معنا',
  },
  zh: {
    eyebrow: '洞察',
    title: '行业新闻与洞察',
    lede: '了解 Grupo BMP 与全球商业格局的最新动态。',
    cta_title: '保持联系',
    cta_body: '联系我们,了解我们最新的倡议与合作伙伴关系。',
    cta_btn: '联系我们',
  },
};

const InsightsPage = () => {
  const { language } = useLanguage();
  const c = COPY[language] || COPY.en;

  return (
    <div className="min-h-screen bg-white" data-testid="insights-page">
      {/* Hero — extends behind the transparent fixed header on this route */}
      <section className="bg-[#023E8A] text-white pt-44 pb-24">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-[#48CAE4]" />
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#48CAE4]" data-testid="insights-eyebrow">{c.eyebrow}</p>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] tracking-tight mb-6" data-testid="insights-title">
              {c.title}
            </h1>
            <p className="text-lg text-white/80 font-light leading-relaxed max-w-2xl" data-testid="insights-lede">
              {c.lede}
            </p>
          </div>
        </div>
      </section>

      <FeaturedBrandStudioArticle />

      <InsightsSectionML />

      {/* CTA */}
      <section className="bg-[#023E8A] py-16">
        <div className="container mx-auto px-6 text-center">
          <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-4" data-testid="insights-cta-title">{c.cta_title}</h3>
          <p className="text-white/70 mb-8 max-w-lg mx-auto" data-testid="insights-cta-body">{c.cta_body}</p>
          <Link to="/contact">
            <button
              className="bg-[#FF6B35] hover:bg-[#E5562D] text-white font-bold px-10 py-4 rounded-xl text-lg transition-all hover:scale-105 inline-flex items-center gap-2"
              data-testid="insights-cta-btn"
            >
              {c.cta_btn} <ArrowRight className="w-5 h-5" />
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default InsightsPage;
